/*
 * This module provides all action types used in the app.
 *
 */

 // choices
export const RESET_CHOICES = 'RESET_CHOICES';
export const ADD_CHOICE = 'ADD_CHOICE';

// currentbranch
export const SET_CURRENT_BRANCH = 'SET_CURRENT_BRANCH';